import { Stack } from '@mui/material';

import InformationSkeleton from './Information/skeleton';
import PollIdentifierSkeleton from './PollIdentifier/skeleton';

const RightPartSkeleton = () => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <PollIdentifierSkeleton />
      <InformationSkeleton />
    </Stack>
  );
};

export default RightPartSkeleton;
